import type { RouteLocationRaw } from 'vue-router';
import { homeRoute } from '@/composables/auth';
import { useBookingsStore } from '@/store/bookings-store';

export default function (): true | RouteLocationRaw {
  const booking = useBookingsStore().booking.selectedBooking;

  return booking?.events?.length ? true : homeRoute();
}
